import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import store from './store'

import moment from 'moment'

import ElementUI from 'element-ui'
import 'normalize.css'
import './style/element.scss'
import './style/app.less'

Vue.use(ElementUI)

Vue.config.productionTip = false

// 十位时间戳，在进来时，一定要加 * 1000
Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  dataStr = dataStr * 1000
  return moment(dataStr).format(pattern)
})

new Vue({
  router,
  render: h => h(App),
  store
}).$mount('#app')

